import React from 'react';
import { Link } from 'react-router-dom';
import LinearProgressBlockScreen from '../share/LinearProgressBlockScreen';
import { Button, IconButton, FormControl, Paper, Slide, Typography,
  withStyles, InputLabel, Select, MenuItem, TextField } from '@material-ui/core';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import { parse, format, subMonths, addDays, isBefore, isEqual, differenceInCalendarDays } from 'date-fns';
import AspectRatio from '@material-ui/icons/AspectRatio';
import VariantSnackbar from '../share/VariantSnackbar';
import CalculoAtuarialService from '../../services/CalculoAtuarialService';
import classnames from 'classnames';

const styles = theme => ({
  searchIcon: {
    marginRight: theme.spacing.unit,
  },
  button: {
    margin: theme.spacing.unit,
    marginRight: theme.spacing.unit * 10,
  },
  titlebar: {
    display: 'flex',
    alignItems: 'center',
  },
  link: {
    textDecoration: 'none',
  },
  body: {
    backgroundColor: '#EDEDEE',
    marginTop: theme.spacing.unit,
    marginBottom: theme.spacing.unit,
  },
  selectTipoArquivo: {
    margin: theme.spacing.unit,
    width: 350,
  },
  selectTipoData: {
    margin: theme.spacing.unit,
    width: 250,
  },
  textField: {
    marginBottom: theme.spacing.unit,
    marginLeft: theme.spacing.unit * 2,
    width: 232,
  },
  iconButton: {
    marginBottom: theme.spacing.unit,
  },
  invisible: {
    display: 'none',
  },
  formControl: {
  },
});

class CalculoAtuarial extends React.Component {
  calculoService = new CalculoAtuarialService();
  state = {
    calcProcTitular: [],
    calcProcDependente: [],
    calcOpmeTitular: [],
    calcOpmeDependente: [],
    calcDespTitular: [],
    calcDespDependente: [],
    calcPrestadores: [],
    calcUsuarios: [],
    calcReceitas: [],
    calcReembolsos: [],
    covidAutorizacao: [],
    covidFaturamento: [],
    fetching: false,
    codTipoArquivoSelected: 1,
    codTipoDataSelected: 0,
    from: format(subMonths(new Date(), 12), 'YYYY-MM-DD'),
    to: format(new Date(), 'YYYY-MM-DD'),
    snackOpen: false,
    snackVariant: 'success',
    snackHorizontal: 'right',
    snackMessage: '',
    sucesso: true,
    errorMessageDataInicial: '',
    errorMessageDataFinal: '',
  }

  handleClickBuscar = async () => {
    this.setState({fetching: true});
    const filtro = {
      codTipoData: this.state.codTipoDataSelected,
      dataInicial: this.state.from === '' ? parse(new Date(0)) : parse(this.state.from),
      dataFinal: this.state.to === '' ? parse(new Date(0)) : parse(this.state.to),
    };
    await this.consultarCalculo(filtro);
    this.setState({fetching: false});
  }

  consultarProcedimentosTitulares = async (filtro) => {
    const calculos = await this.calculoService.consultarProcedimentosTitulares(filtro);
    this.setState({ calcProcTitular: calculos });
  }
  consultarProcedimentosDependentes = async (filtro) => {
    const calculos = await this.calculoService.consultarProcedimentosDependentes(filtro);
    this.setState({ calcProcDependente: calculos });
  }
  consultarOpmesTitulares = async (filtro) => {
    const calculos = await this.calculoService.consultarOpmesTitulares(filtro);
    this.setState({ calcOpmeTitular: calculos });
  }
  consultarOpmesDependentes = async (filtro) => {
    const calculos = await this.calculoService.consultarOpmesDependentes(filtro);
    this.setState({ calcOpmeDependente: calculos });
  }
  consultarDespesasTitulares = async (filtro) => {
    const calculos = await this.calculoService.consultarDespesasTitulares(filtro);
    this.setState({ calcDespTitular: calculos });
  }
  consultarDespesasDependentes = async (filtro) => {
    const calculos = await this.calculoService.consultarDespesasDependentes(filtro);
    this.setState({ calcDespDependente: calculos });
  }
  consultarCalculoPrestadores = async (filtro) => {
    const calculos = await this.calculoService.consultarCalculoPrestadores(filtro);
    this.setState({ calcPrestadores: calculos });
  }
  consultarCalculoUsuarios = async (filtro) => {
    const calculos = await this.calculoService.consultarCalculoUsuarios(filtro);
    this.setState({ calcUsuarios: calculos });
  }
  consultarCalculoReceitas = async (filtro) => {
    const calculos = await this.calculoService.consultarCalculoReceitas(filtro);
    this.setState({ calcReceitas: calculos });
  }
  consultarCalculoReembolsos = async (filtro) => {
    const calculos = await this.calculoService.consultarCalculoReembolsos(filtro);
    this.setState({ calcReembolsos: calculos });
  }
  consultarCovidAutorizacao = async (filtro) => {
    const calculos = await this.calculoService.consultarCovidAutorizacao(filtro);
    this.setState({ covidAutorizacao: calculos });
  }
  consultarCovidFaturamento = async (filtro) => {
    const calculos = await this.calculoService.consultarCovidFaturamento(filtro);
    this.setState({ covidFaturamento: calculos });
  }

  consultarCalculo = async (filtro) => {
    let calculos = [];
    let nomeArquivo = '';
    // Arquivo de DESPESAS
    if (this.state.codTipoArquivoSelected === 1) {
      let dataInicialAux = filtro.dataInicial;
      let dataFinalAux = filtro.dataInicial;
      nomeArquivo = 'despesas_de_' + 
      format(new Date(filtro.dataInicial), 'DD_MM_YYYY') + '_a_' + 
      format(new Date(filtro.dataFinal), 'DD_MM_YYYY') + '.csv';

      while (isBefore(dataFinalAux, filtro.dataFinal) || isEqual(dataFinalAux, filtro.dataFinal)){
        let i = 1;
        while (i <= 30){
          dataFinalAux = addDays(dataFinalAux, 1);
          i = i + 1;
          if (isEqual(dataFinalAux, filtro.dataFinal)){
            break;
          }
        }
        let filtroAux = {
          codTipoData: this.state.codTipoDataSelected,
          dataInicial: dataInicialAux,
          dataFinal: dataFinalAux,
        };
        await Promise.all([this.consultarProcedimentosTitulares(filtroAux),
          this.consultarProcedimentosDependentes(filtroAux),
          this.consultarOpmesTitulares(filtroAux),
          this.consultarOpmesDependentes(filtroAux),
          this.consultarDespesasTitulares(filtroAux),
          this.consultarDespesasDependentes(filtroAux)]);
    
        calculos = calculos.concat(this.state.calcProcTitular);
        calculos = calculos.concat(this.state.calcProcDependente);
        calculos = calculos.concat(this.state.calcOpmeTitular);
        calculos = calculos.concat(this.state.calcOpmeDependente);
        calculos = calculos.concat(this.state.calcDespTitular);
        calculos = calculos.concat(this.state.calcDespDependente);  
        dataInicialAux = addDays(dataFinalAux, 1);
        dataFinalAux = addDays(dataFinalAux, 1);
      }
    }
    // Arquivo de PRESTADOR
    if (this.state.codTipoArquivoSelected === 2) {
      nomeArquivo = 'prestadores_de_' + 
      format(new Date(filtro.dataInicial), 'DD_MM_YYYY') + '_a_' + 
      format(new Date(filtro.dataFinal), 'DD_MM_YYYY') + '.csv';
      await this.consultarCalculoPrestadores(filtro);
      calculos = this.state.calcPrestadores;
    }
    // Arquivo de USUÁRIO
    if (this.state.codTipoArquivoSelected === 3) {
      nomeArquivo = 'usuarios_de_' + 
      format(new Date(filtro.dataInicial), 'DD_MM_YYYY') + '_a_' + 
      format(new Date(filtro.dataFinal), 'DD_MM_YYYY') + '.csv';
      await this.consultarCalculoUsuarios(filtro);
      calculos = this.state.calcUsuarios;
    }
    // Arquivo de RECEITAS
    if (this.state.codTipoArquivoSelected === 4) {
      let dataInicialAux = filtro.dataInicial;
      let dataFinalAux = filtro.dataInicial;
      nomeArquivo = 'receitas_de_' + 
      format(new Date(filtro.dataInicial), 'DD_MM_YYYY') + '_a_' + 
      format(new Date(filtro.dataFinal), 'DD_MM_YYYY') + '.csv';

      while (isBefore(dataFinalAux, filtro.dataFinal) || isEqual(dataFinalAux, filtro.dataFinal)){
        let i = 1;
        while (i <= 30){
          dataFinalAux = addDays(dataFinalAux, 1);
          i = i + 1;
          if (isEqual(dataFinalAux, filtro.dataFinal)){
            break;
          }
        }
        let filtroAux = {
          codTipoData: this.state.codTipoDataSelected,
          dataInicial: dataInicialAux,
          dataFinal: dataFinalAux,
        };
        await this.consultarCalculoReceitas(filtroAux);
    
        calculos = calculos.concat(this.state.calcReceitas);
        dataInicialAux = addDays(dataFinalAux, 1);
        dataFinalAux = addDays(dataFinalAux, 1);
      }
    }
    // Arquivo de REEMBOLSOS
    if (this.state.codTipoArquivoSelected === 5) {
      nomeArquivo = 'reembolsos_de_' + 
      format(new Date(filtro.dataInicial), 'DD_MM_YYYY') + '_a_' + 
      format(new Date(filtro.dataFinal), 'DD_MM_YYYY') + '.csv';
      await this.consultarCalculoReembolsos(filtro);
      calculos = this.state.calcReembolsos;
    }
    // Arquivo de COVID Autorização
    if (this.state.codTipoArquivoSelected === 6) {
      let dataInicialAux = filtro.dataInicial;
      let dataFinalAux = filtro.dataInicial;
      nomeArquivo = 'covid_autorizacao_de_' + 
      format(new Date(filtro.dataInicial), 'DD_MM_YYYY') + '_a_' + 
      format(new Date(filtro.dataFinal), 'DD_MM_YYYY') + '.csv';

      while (isBefore(dataFinalAux, filtro.dataFinal) || isEqual(dataFinalAux, filtro.dataFinal)){
        let i = 1;
        while (i <= 30){
          dataFinalAux = addDays(dataFinalAux, 1);
          i = i + 1;
          if (isEqual(dataFinalAux, filtro.dataFinal)){
            break;
          }
        }
        let filtroAux = {
          codTipoData: this.state.codTipoDataSelected,
          dataInicial: dataInicialAux,
          dataFinal: dataFinalAux,
        };
        await this.consultarCovidAutorizacao(filtroAux);
    
        calculos = calculos.concat(this.state.covidAutorizacao);
        dataInicialAux = addDays(dataFinalAux, 1);
        dataFinalAux = addDays(dataFinalAux, 1);
      }
    }
    // Arquivo de COVID Faturamento
    if (this.state.codTipoArquivoSelected === 7) {
      let dataInicialAux = filtro.dataInicial;
      let dataFinalAux = filtro.dataInicial;
      nomeArquivo = 'covid_faturamento_de_' + 
      format(new Date(filtro.dataInicial), 'DD_MM_YYYY') + '_a_' + 
      format(new Date(filtro.dataFinal), 'DD_MM_YYYY') + '.csv';

      while (isBefore(dataFinalAux, filtro.dataFinal) || isEqual(dataFinalAux, filtro.dataFinal)){
        let i = 1;
        while (i <= 30){
          dataFinalAux = addDays(dataFinalAux, 1);
          i = i + 1;
          if (isEqual(dataFinalAux, filtro.dataFinal)){
            break;
          }
        }
        let filtroAux = {
          codTipoData: this.state.codTipoDataSelected,
          dataInicial: dataInicialAux,
          dataFinal: dataFinalAux,
        };
        await this.consultarCovidFaturamento(filtroAux);
    
        calculos = calculos.concat(this.state.covidFaturamento);
        dataInicialAux = addDays(dataFinalAux, 1);
        dataFinalAux = addDays(dataFinalAux, 1);
      }
    }
    this.gerarArquivo(calculos, nomeArquivo);
  }
  gerarArquivo = (calculos, nomeArquivo) => {
    let conteudo = '';
    let jaInseriuCabecalho = false;

    for (var i = 0; i < calculos.length; i++) {
      if (calculos[i].nome.includes('UROGINECOLÓGICA')){
        conteudo = conteudo + calculos[i].nome;
      } else {        
        if (calculos[i].nome.includes('SEQ_PROCEDIMENTO') ||
        calculos[i].nome.includes('NUM_TIT') ||
        calculos[i].nome.includes('COD_PREST') ||
        calculos[i].nome.includes('NUM_USU') ||
        calculos[i].nome.includes('DTA_ATENDIMENTO') ||
        calculos[i].nome.includes('DTA_EMISSAO_PRESTADOR')) {
          if (!jaInseriuCabecalho) {
            conteudo = conteudo + calculos[i].nome + '\n';
          }
        } else {
          conteudo = conteudo + calculos[i].nome + '\n';
        }
      }      
      if (calculos[i].nome.includes('SEQ_PROCEDIMENTO') ||
      calculos[i].nome.includes('NUM_TIT') ||
      calculos[i].nome.includes('COD_PREST') ||
      calculos[i].nome.includes('NUM_USU') ||
      calculos[i].nome.includes('DTA_ATENDIMENTO') ||
      calculos[i].nome.includes('DTA_EMISSAO_PRESTADOR')) {
        jaInseriuCabecalho = true;
      }
    }
    const url = window.URL.createObjectURL(new Blob([conteudo]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', nomeArquivo);
    document.body.appendChild(link);
    link.click();
    link.parentNode.removeChild(link);    
  }
  handleChange = event => {
    this.setState({
      [event.target.name]: event.target.value,
    });
  }
  handleCloseSnackbar = () => {
    this.setState({ snackOpen: false });
  }
  isBuscarDisabled = () => {
    return (this.state.errorMessageDataInicial !== '' ||
     this.state.from === undefined ||
     this.state.from === 'Invalid Date' ||
     this.state.from === '') ||

     (this.state.errorMessageDataFinal !== '' ||
     this.state.to === undefined ||
     this.state.to === 'Invalid Date' ||
     this.state.to === '');
  }
  handleBlurDataInicial = event => {
    if (this.state.from === null ||
      this.state.from === undefined ||
      this.state.from === '') {
      this.setState({errorMessageDataInicial: 'Este campo é obrigatório'});
    } else {
      this.setState({errorMessageDataInicial: ''});
    }
  }
  handleBlurDataFinal = event => {
    if (this.state.to === null ||
      this.state.to === undefined ||
      this.state.to === '') {
      this.setState({errorMessageDataFinal: 'Este campo é obrigatório'});
    } else {
      if (isBefore(this.state.to, this.state.from)){
        this.setState({errorMessageDataFinal: 'Data fim menor que data início'});
      } else {
        if(differenceInCalendarDays(this.state.to, this.state.from) > 366) {
          this.setState({errorMessageDataFinal: 'Período maior que um ano'});
        } else {
          this.setState({errorMessageDataFinal: ''});
        }
      }
    }
  }

  render () {
    const { classes } = this.props;
    const { fetching, codTipoArquivoSelected, codTipoDataSelected,
      from, to } = this.state;
    return (
      <React.Fragment>
        <Link to='/relatorio' className={classes.link}>
          <Slide direction='down' timeout={600} in>
            <Paper elevation={1} className={classes.titlebar}>
              <IconButton color='inherit' aria-label='Close'>
                <ChevronLeft />
              </IconButton>
              <Typography variant='headline'>Cálculo Atuarial</Typography>
            </Paper>
          </Slide>
        </Link>
        {fetching ? <LinearProgressBlockScreen /> : null}
        <Paper className={classes.body} elevation={1}>
            <FormControl>
              <InputLabel shrink htmlFor='tipo-simple' className={classes.selectTipoArquivo}>
                Tipo de Arquivo
              </InputLabel>
              <Select
                className={classes.selectTipoArquivo}
                value={codTipoArquivoSelected}
                onChange={this.handleChange}
                inputProps={{
                  name: 'codTipoArquivoSelected',
                }}
              >
                <MenuItem key={1} value={1}>1 - Despesas</MenuItem>
                <MenuItem key={2} value={2}>2 - Prestadores</MenuItem>
                <MenuItem key={3} value={3}>3 - Usuários</MenuItem>
                <MenuItem key={4} value={4}>4 - Receitas</MenuItem>
                <MenuItem key={5} value={5}>5 - Reembolsos</MenuItem>
                <MenuItem key={5} value={6}>6 - Covid Autorização</MenuItem>
                <MenuItem key={5} value={7}>7 - Covid Faturamento</MenuItem>
              </Select>
            </FormControl>
            <FormControl className={classnames(classes.formControl, {
                  [classes.invisible]: this.state.codTipoArquivoSelected !== 1
                })}>
              <InputLabel shrink htmlFor='tipo-simple' className={classes.selectTipoData}>
                Tipo de Data
              </InputLabel>
              <Select
                className={classes.selectTipoData}
                value={codTipoDataSelected}
                onChange={this.handleChange}
                inputProps={{
                  name: 'codTipoDataSelected',
                }}
              >
                <MenuItem key={0} value={0}>Data de Pagamento</MenuItem>
                <MenuItem key={1} value={1}>Data de Execução</MenuItem>
              </Select>
            </FormControl>
            <TextField
              id='date'
              error={this.state.errorMessageDataInicial !== ''}
              label={this.state.errorMessageDataInicial !== '' ? this.state.errorMessageDataInicial : 'De'}
              type='date'
              value={from}
              onChange={this.handleChange}
              onBlur={this.handleBlurDataInicial}
              inputProps={{
                name: 'from',
              }}
              className={classes.textField}
              InputLabelProps={{
                shrink: true,
              }}
            />
            <TextField
              id='date'
              error={this.state.errorMessageDataFinal !== ''}
              label={this.state.errorMessageDataFinal !== '' ? this.state.errorMessageDataFinal : 'Até'}
              className={classes.textField}
              type='date'
              value={to}
              onChange={this.handleChange}
              onBlur={this.handleBlurDataFinal}
              inputProps={{
                name: 'to',
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
            <FormControl>
              <Button
                disabled={this.isBuscarDisabled()}
                variant='extendedFab'
                title='Buscar'
                type='submit'
                onClick={this.handleClickBuscar}
                onTouchStart={this.handleClickBuscar}
                className={classes.button}>
                <AspectRatio className={classes.searchIcon} />
                Gerar Arquivo
              </Button>
            </FormControl>
          </Paper>
        <VariantSnackbar
          vertical={'top'}
          horizontal={'right'}
          variant={this.state.sucesso ? 'success' : 'error'}
          message={this.state.snackMessage}
          open={this.state.snackOpen}
          handleClose={this.handleCloseSnackbar} />
      </React.Fragment>
    );
  }
}
export default withStyles(styles)(CalculoAtuarial);
